export default __webpack_public_path__ + "static/media/discord.ecc9f511.svg";